import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import { ReservationStatusPill } from "../ReservationStatusPill";
import styles from "../ReservationStatusPill/ReservationStatusPill.module.scss";
import type { TripsReservationStatusPillProps } from "./types";
import { useTripsReservationStatusPill } from "./useTripsReservationStatusPill";

export const TripsReservationStatusPill = (
  props: TripsReservationStatusPillProps
) => {
  const [block] = useModuleBEM(styles, "ReservationStatusPill");
  const { className } = props;
  const result = useTripsReservationStatusPill(props);

  if (!result) {
    return null;
  }

  return (
    <ReservationStatusPill
      tone={result.tone}
      className={clsx(block, className)}
    >
      {result.label}
    </ReservationStatusPill>
  );
};
